import "./index.scss";

import { Popup } from "vant";
import { Component, Vue } from "vue-property-decorator";

import PickerManager from "@/shared/tools/pickerManager";
import { OptionItem } from "@/model/OptionItem";
import { ActionPickerOptions } from "./types";

@Component({ name: "ActionPicker" })
class ActionPicker extends Vue {
  private visible = false;

  private options: ActionPickerOptions | null = null;

  public open(options: ActionPickerOptions) {
    this.options = {
      title: "",
      cancelText: "",
      valueKey: "name",
      ...options,
    };

    this.visible = true;
  }

  public close() {
    this.visible = false;
  }

  private onSelect(item: OptionItem) {
    if (this.options) {
      this.options.onConfirm(item);
    }

    this.visible = false;
  }

  private onCancel() {
    this.visible = false;
  }

  private render() {
    return this.options ? (
      <Popup
        class="ActionPicker"
        position="bottom"
        v-model={this.visible}
        closeOnClickOverlay={false} // 在弹窗中点击选择器的overlay会关闭弹窗，因此先禁止
      >
        <div class="ActionPicker__main">
          {this.options.title && (
            <div class="ActionPicker__title">{this.options.title}</div>
          )}
          <div class="ActionPicker__list">
            {this.options.columns.map((item) => (
              <div
                class="ActionPicker__list-item"
                onClick={this.onSelect.bind(this, item)}
              >
                {/* @ts-ignore */}
                {item[this.options.valueKey || "name"]}
              </div>
            ))}
          </div>
        </div>

        {this.options.cancelText && (
          <div class="ActionPicker__cancel" onClick={this.onCancel}>
            {this.options.cancelText}
          </div>
        )}
      </Popup>
    ) : null;
  }
}

const instance = new ActionPicker().$mount();

document.body.appendChild(instance.$el);
PickerManager.addPicker(instance);

export const actionPicker = instance;
